const models = require('powerbi-models');  // load enums to use for config


const reportInfo = $('#powerBiReportInfo');
const accessToken = reportInfo.find('#EmbedToken_Token').val();
const url = reportInfo.find('#EmbedUrl').val();
const reportId = reportInfo.find('#Id').val();
const config = {
  type: 'report',
  tokenType: models.TokenType.Embed,
  accessToken: accessToken,
  embedUrl: url,
  id: reportId,
  permissions: models.Permissions.All,
  settings: {
    filterPaneEnabled: false,
    navContentPaneEnabled: false,
    panes: {
      filters: {
        visible: false
      },
      pageNavigation: {
        visible: false
      }
    },
  }
};

export default function() {
  const reportContainer = $('#powerBiReportContainer')[0];
  powerbi.embed(reportContainer, config);
}